// The public figures directory (15 October 2026): the page, its filters, its cards.
// A person's gender is never guessed; never a number of mentions.
export default {
  titre: 'Public figures',
  sousTitre: {
    total: '{n} political figures',
    institutions: 'Parliament, Government, European Parliament, parties, regions and major cities',
    aJour: 'updated {date}',
  },
  ajouter: 'Add a public figure',
  filtres: {
    aria: 'Filters',
    pays: 'Country',
    rechercher: 'Search public figures',
    placeholder: 'A name, a constituency, a ministry',
    suivies: 'Followed only',
    institution: 'Institution',
    toutes: 'All',
    groupe: 'Group',
    court: { AN: 'NA', SENAT: 'Senate' },
  },
  compte: {
    une: 'One public figure',
    n: '{n} public figures',
    uneSur: 'One public figure out of {total}',
    nSur: '{n} public figures out of {total}',
  },
  ordre: 'Alphabetical order',
  grille: 'Public figures',
  comptes: 'Accounts: ',
  chargement: 'Loading the directory…',
  vide: {
    titre: 'No public figure matches',
    texte: 'Try another search, or remove a filter.',
    aucunSuivi: 'No one followed yet. Following a public figure starts listening to them, every day.',
    effacer: 'Clear filters',
  },
}
